<template lang="pug">
  div.container-fluid.animated.fadeIn
    nav(aria-label="breadcrumb")
      b-breadcrumb
        b-breadcrumb-item
          router-link(to="/system")
            i.fa.fa-desktop
            span.ml-1 {{ $t("ui.system") }}
        b-breadcrumb-item
          router-link(to="/system/ip")
            i.fa.fa-map-marker
            span.ml-1 {{ $t("ui.ip") }}
    div.row.mb-5
      div.col-md-12
        div.card
          div.card-header
            div.row
              div.col-md-12.mb-1
                div.form-row
                  div.col-sm-9.col-md-6.mb-1
                    b-input-group(size="sm")
                      b-input-group-text(slot="prepend")
                        i.icon-magnifier
                      DebounceInput(required autofocus type="text" v-model="ipSearch" :placeholder="$t('message.search_by_id_name')")
                  div.col-sm-3.col-md-1.mb-1
                    b-form-radio-group(
                      buttons
                      v-model="filterBy"
                      size="sm"
                      button-variant="outline-info"
                    )
                      b-form-radio(value="ip") {{ $t("ui.ip") }}
                      b-form-radio(value="updated_by") {{ $t("ui.updated_by") }}
              div.col-md-12
                b-button(v-b-modal.addIp type="button" variant="primary" size="sm").mr-1
                  i.fa.fa-plus
                  span {{ $t("ui.combine.add_ip") }}
          div.card-body.p-1.clusterize
            .clusterize-scroll
              table.tablex(style="width: auto;" v-columns-resizable)
                thead
                  tr
                    th.sticky-position
                      span {{ $t('ui.id') }}
                    th.text-center.sticky-position(width=120)
                      span {{ $t("ui.action") }}
                    th.sticky-position
                      span {{ $t("ui.updated_by") }}
                    th.sticky-position
                      span {{ $t("ui.remark") }}
                    th.text-right.sticky-position(width=200)
                      span {{ $t("ui.created_on") }}
                tbody.clusterize-content
                  tr(v-for="(item, index) in filteredIpList")
                    td
                      span {{ item.ip }}
                    td.actions
                      span
                        a.fa.fa-trash.text-danger(href="#" @click="onDelete(item)" :title="$t('ui.delete')")
                    td
                      span {{ item.updated_by }}
                    td
                      span {{ item.remark }}
                    td.text-right
                      span {{ $moment(item.created_on).format("YYYY-MM-DD, HH:mm:ss") }}
      addip(@clicked="addIp" @failed="handleFailed")
      deleteip(ref="deleteip" :ip="deleteSelectedIp" @clicked="deleteIp" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import addip from "@/components/ip/addIp.vue";
import deleteip from "@/components/ip/deleteIp.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    addip,
    deleteip,
    DebounceInput
  },
  data() {
    return {
      filterBy: "ip",
      ipList: [],
      ipSearch: "",
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
      deleteSelectedIp: ""
    };
  },
  computed: {
    filteredIpList() {
      return this.ipList.filter(ipInfo => {
        if (this.filterBy == "updated_by") {
          return ipInfo.updated_by.toLowerCase().indexOf(this.ipSearch.toLowerCase()) > -1;
        } else {
          return ipInfo.ip.indexOf(this.ipSearch.toLowerCase()) > -1;
        }
      });
    }
  },
  mounted: function() {
    this.getIpList();
  },
  methods: {
    getIpList() {
      let url = config.ipListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.ip
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.ipList = response.data.tbl_ip_list;
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    onDelete(e) {
      this.deleteSelectedIp = e.ip;
      this.$refs.deleteip.$refs.deleteIp.show();
    },
    addIp: function(ip) {
      // let newIp = {
      //   ip: ip,
      //   updated_by: this.$store.getters.username,
      //   created_on: new Date()
      // };

      // this.ipSearch = "";
      // this.ipList.unshift(newIp);
      this.getIpList();
      this.$helpers.showDialog(this.$t("ui.combine.add_ip"), this.$t("message.success"), "success");
    },
    deleteIp: function(ip) {
      // let i = this.ipList
      //   .map(ipInfo => {
      //     return ipInfo.ip;
      //   })
      //   .indexOf(ip);
      // this.ipList.splice(i, 1);
      this.getIpList();
      this.$helpers.showDialog(this.$t("ui.combine.delete_ip"), this.$t("message.success"), "success");
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
